const subscription = {
    limit_exceeded: 'Bạn đã đạt giới hạn của gói đăng ký hiện tại.',
    get_plan_failed: 'Không thể lấy thông tin gói đăng ký cho tenant.',
    tenant_suspended: 'Tenant đã bị tạm ngưng. Vui lòng liên hệ quản trị viên.',
};
export default Object.freeze(subscription);
